'use client';

import { FC } from 'react';

import { StepFormError } from '@/steps-form/components/StepFormError/StepFormError';
import { ErrorPageProps } from '@/types/appRouter.types';

const ErrorForm: FC<ErrorPageProps> = (props) => (
  <StepFormError {...props} exceptionDescription="Submission error in auth form" />
);

export default ErrorForm;
